/** Scan & Share counter display helpers - one source for the badge text and badge colours. */

/** "Counter 1 · OPD"; a counter that is not in Settings (unknown type) is just "Counter 3". */
export function counterBadge(counterId, counterType) {
  if (!counterId) return '';
  return counterType ? `Counter ${counterId} · ${counterType}` : `Counter ${counterId}`;
}

export const TYPE_BADGE_CLASS = {
  OPD: 'bg-teal-100 dark:bg-teal-900/60 text-teal-900 dark:text-teal-100 border-teal-400 dark:border-teal-600',
  IPD: 'bg-indigo-100 dark:bg-indigo-900/60 text-indigo-900 dark:text-indigo-100 border-indigo-400 dark:border-indigo-500',
  UNKNOWN: 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 border-slate-400 dark:border-slate-600',
};

export const typeBadgeClass = (type) => TYPE_BADGE_CLASS[type] || TYPE_BADGE_CLASS.UNKNOWN;
